var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-8"},[_c('div',[_c('ActivityLogList',{ref:"activityLogList",attrs:{"contact-id":_vm.contactId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }